import { LikeContents } from "../../../../../../data/applications/SocialApp";

const LikeContent = () => {
  
  return (
    <div className="like-content">
      <span>
        <i className="fa fa-heart font-danger" />
      </span>
      {LikeContents.map((item, index) => (
        <span className="pull-right comment-number" key={index}>
          <span>{item.count}</span>
          <span>
            <i className={`fa fa-${item.icon}`} />
          </span>
        </span>
      ))}
    </div>
  );
};

export default LikeContent;